import React from 'react';
import { styleOptions } from '../data/vehicleData.js';

const StyleSelector = ({ selectedStyle, onStyleChange }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800">Image Style</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {styleOptions.map((style) => (
          <div
            key={style.id}
            onClick={() => onStyleChange(style.id)}
            className={`p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 ${
              selectedStyle === style.id
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 bg-white hover:border-gray-300'
            }`}
          >
            <h4 className="font-medium text-gray-800">{style.name}</h4>
            <p className="text-sm text-gray-600 mt-1">{style.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StyleSelector;